import React from 'react'
import neon from '../../Images/Konami/neon.jpg'
import sign from '../../Images/Konami/sign.jpg'

export default function Sales() {
    return (
        <div><br/><br/>
            <center><img src={neon} alt='neon' height='300px' /></center><br/>
            <center><img src={sign} alt='sign' height='300px'/></center><br/>
        </div>
    )
}


